export default "__VITE_ASSET__B5NK3Op$__"